import React from "react";

export default ({ emphasized = false, rotation = 0 }) => (
    <line
        x1="0"
        y1={emphasized ? 0.15 : 0.1}
        x2="0"
        y2="0"
        strokeWidth={emphasized ? 0.015 : 0.01}
        stroke={emphasized ? "#333333" : "#757575"}
        transform={`translate(0 -1) rotate(${rotation} 0 1)`}
    />
);
